<template>
  <form class="mt-4"
        @submit.prevent="updateOdkData">
    <div class="row justify-content-start mb-2">
      <div class="col-md-12 col-sm-12">
        <h4>{{ $t('ManageSystemView.odkSettings') }}</h4>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-12 col-sm-12 form-group mb-4">
        <label class="form-label"
               for="odkUrl">
          {{ $t('odkUrl') }}
        </label>
        <input type="text"
               id="odkUrl"
               class="form-control rounded-pill"
               placeholder=""
               v-model="this.odkUrl"/>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-md-6 col-sm-12 form-group mb-4">
        <label class="form-label"
               for="odkUsername">
          {{ $t('odkUsername') }}
        </label>
        <input type="text"
               id="odkUsername"
               class="form-control rounded-pill"
               placeholder=""
               v-model="this.odkUsername"/>
      </div>

      <div class="col-md-6 col-sm-12 form-group mb-4">
        <label class="form-label"
               for="odkPassword">
          {{ $t('odkPassword') }}
        </label>
        <input type="text"
               id="odkPassword"
               class="form-control rounded-pill"
               placeholder=""
               v-model="this.odkPassword"/>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-md-4 col-sm-12 form-group mb-4">
        <label class="form-label"
               for="odkProjectId">
          {{ $t('odkProjectId') }}
        </label>
        <input type="text"
               id="odkProjectId"
               class="form-control rounded-pill"
               placeholder=""
               v-model="this.odkProjectId"/>
      </div>
      <div class="col-md-4 col-sm-12 form-group mb-4">
        <label class="form-label"
               for="odkCachingTime">
          {{ $t('odkCachingTime') }}
        </label>
        <input type="number"
               id="odkCachingTime"
               class="form-control rounded-pill"
               v-model="this.odkCachingTime"/>
      </div>
      <div class="col-md-4 col-sm-12 form-group mb-4">
        <label class="form-label"
               for="odkCachingdirectory">
          {{ $t('odkCachingDirectory') }}
        </label>
        <input type="text"
               id="odkCachingdirectory"
               class="form-control rounded-pill"
               placeholder=""
               v-model="this.odkCachingDirectory"/>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col col-md-6 col-sm-12 form-group">
        <button type="submit"
                class="btn btn-success rounded-pill mb-4 w-100">
          <i class="bi bi-plus-circle"></i> {{ $t('save') }}
        </button>
      </div>
    </div>

  </form>
</template>

<script>
import {getAllSettings, putSettings} from "@/utils";

export default {
  data() {
    return {
      odkUrl: "",
      odkUsername: "",
      odkPassword: "",
      odkProjectId: "",
      odkCachingTime: 0,
      odkCachingDirectory: "",
      message: "",
      messageType: "",
    }
  },
  async mounted() {
    let response = await getAllSettings();
    if (response.status === 200) {
      this.odkUrl = response.data.odk_url;
      this.odkUsername = response.data.odk_user;
      this.odkPassword = "";
      this.odkProjectId = response.data.odk_projectId;
      this.odkCachingTime = response.data.odk_cacheTime;
      this.odkCachingDirectory = response.data.odk_cacheDirectory;
    } else {
      this.message = response.response.data.message;
      this.messageType = "danger";
    }
  },
  methods: {
    async updateOdkData() {
      await putSettings({
        'odk_url': this.odkUrl,
        'odk_username': this.odkUsername,
        'odk_pw': this.odkPassword,
        'odk_projectId': this.odkProjectId,
        'odk_cacheTime': this.odkCachingTime,
        'odk_cacheDirectory': this.odkCachingDirectory,
      });
    }
  }
}
</script>


